import React from 'react'
import { Card } from 'semantic-ui-react'
import styled, { keyframes } from 'styled-components'

const placeHolderShimmer = keyframes`
  0%{
    background-position: -468px 0;
  }
  100%{
    background-position: 468px 0;
  }
`

const StyledCard = styled(Card)`
  ${({ theme }) => ({
    '&.ui.card.loading': {
      border: 'solid 1px #d4d4d5',
      '.product-image': {
        height: '22em',
      },
      '.is-loading': {
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: `${placeHolderShimmer}`,
        animationTimingFunction: 'linear',
        background: 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)',
        backgroundSize: '800px 104px',
        position: 'relative',
      },
      '.loading-content': {
        height: '20px',
        marginBottom: '5px',
      },
    },
  })}
`

const ProductLoading = () => {
  return (
    <StyledCard className="loading">
      <div className="product-image is-loading" />
      <Card.Content>
        <div className="loading-content is-loading" />
        <div className="loading-content is-loading" />
      </Card.Content>
    </StyledCard>
  )
}

ProductLoading.propTypes = {}
ProductLoading.defaultProps = {}

export default ProductLoading



// WEBPACK FOOTER //
// ./src/cms/components/productCard/ProductLoading.js